import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { graphQueryBang } from "shared/lib/graphql"

import SearchInput from "./search_input"
import Spinner from "../../../shared/components/spinner"
import { trackClickServiceSelected } from "./utils/telemetry"

import "./service_selector.scss"

export default function ServiceSelector({
  loading,
  onServiceSelect,
  onServiceSelectQuery,
  services,
  stepType,
  updateLoading,
}) {
  const [visibleServices, updateVisibleServices] = useState(services)

  useEffect(() => {
    updateVisibleServices(services)
  }, [services])

  const onSearchResult = serviceIds => {
    const visibleServices = services
      .filter(s => serviceIds.includes(s.id))
      .sort(
        (first, second) =>
          serviceIds.indexOf(first.id) - serviceIds.indexOf(second.id)
      )

    updateVisibleServices(visibleServices)
  }

  const onClick = service => {
    if (loading) return null

    updateLoading(true)

    trackClickServiceSelected({
      serviceModuleName: service.module_name,
      stepType,
    })

    graphQueryBang(onServiceSelectQuery, {
      serviceModuleName: service.module_name,
    })
      .then(data => {
        onServiceSelect({ ...service, ...data.channel })
      })
      .catch(() => updateLoading(false))
  }

  const tiles = () => {
    if (!visibleServices) return null

    return visibleServices.map(s => {
      const style = { backgroundColor: s.brand_color }
      return (
        <li
          key={s.module_name}
          styleName="service-tile"
          style={style}
          role="listitem"
        >
          <a title={`Choose service ${s.name}`} onClick={() => onClick(s)}>
            <div>
              <img src={s.image} alt={s.name} title={s.name} />
              <span>{s.name}</span>
            </div>
          </a>
        </li>
      )
    })
  }

  return (
    <div styleName="service-selector">
      <>
        {loading || !services.length ? (
          <Spinner />
        ) : (
          <>
            <SearchInput services={services} onSearch={onSearchResult} />
            <ul styleName={`service-grid`} role="list">
              {tiles()}
            </ul>
          </>
        )}
      </>
    </div>
  )
}

ServiceSelector.propTypes = {
  loading: PropTypes.bool.isRequired,
  onServiceSelect: PropTypes.func.isRequired,
  onServiceSelectQuery: PropTypes.string.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      module_name: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.string,
      brand_color: PropTypes.string,
    })
  ).isRequired,
  stepType: PropTypes.oneOf(["trigger", "query", "action"]).isRequired,
  updateLoading: PropTypes.func.isRequired,
}
